import { render } from "./Avatar.vue?vue&type=template&id=267ca30e&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=267ca30e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267ca30e"]])

export default __exports__